const pulsechillTNC = {
  header: "Pulse & Chill Terms and Condition",
  body: [
    {
      title: "GENERAL TERMS",
      details: `The MTN Pulse and Chill Promo (the “Promo”) is based on points accrued for voice and data usage on MTN Pulse.`,
    },
    {
      title: ``,
      details: `A customer earns forty (40) points for every GHS1 purchased on MTN Pulse App only.`,
    },
    {
      title: ``,
      details: `Every 1 minute of voice usage comes with one (1) point while every megabyte of data usage earns one (1) point.`,
    },
    {
      title: ``,
      details: `The minimum monthly spend that qualifies a customer for winner selection is Ten Ghana Cedis (GHS10.00).`,
    },
    {
      title: ``,
      details: `Accrued points are not transferable for the duration of the Promo.`,
    },
    {
      title: ``,
      details: `Usage of bonus credits will not accrue points.`,
    },
    {
      title: ``,
      details: `Any Mashup purchase outside MTN Pulse App does not attract any point.`,
    },
    {
      title: ``,
      details: `Customers can check their accumulated points by dialing *567# and select option 5 (Check Pulse Points).`,
    },
    {
      title: ``,
      details: `By activating the Promo, the customer agrees to be bound by these Terms and Conditions.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to amend or revise the Terms and Conditions and shall take steps to notify customers of such amendments. Such amendments shall be posted on MTN’s website and on the Pulse App. We advise you to periodically review these terms and conditions.`,
    },
    {
      title: ``,
      details: `Points will be cleared at the end of every month during the promo period.`,
    },
    {
      title: ``,
      details: `MTN provides the Promo on an "as is" and "as available" basis, in the hope that you find it useful.`,
    },
    {
      title: ``,
      details: `MTN does not warrant that the Promo will be free of errors, faults or interruptions and we shall not be liable to you in connection with (but not limited to): a. any cause beyond our reasonable control \nb. any failure or delay in the use of or inability to use any component of the service. \nc. any loss, claim or damage including loss or corruption of data howsoever arising.`,
    },
    {
      title: `PRIZES`,
      details: `The selection of monthly winners will be based on ranking in the order of highest points accrued by a customer.`,
    },
    {
      title: ``,
      details: `Monthly prize winners will be allocated prizes as listed below per month for the two-month period.`,
    },
    {
      title: `Position - Prize`,
      details: ``,
    },
    {
      title: `1st to 30th `,
      details: `Apple Air Pod Pro`,
    },
    {
      title: `31st to 55th`,
      details: `Samsung A52`,
    },
    {
      title: `56th to 131st `,
      details: `GHS252.25 E-cash + commission`,
    },
    {
      title: `132nd to206th`,
      details: `GHS 100 Melcom Shopping voucher`,
    },
    {
      title: `207th to 281st`,
      details: `  GHS100 Potbelly shack voucher`,
    },
    {
      title: `282nd to 431st`,
      details: `GHS 50 KFC voucher`,
    },
    {
      title: `432nd to 3431st`,
      details: `3GB Data`,
    },
    {
      title: `3432nd to 6431st`,
      details: `GHS 30 Airtime`,
    },
    {
      title: ``,
      details: `Winners will be notified only by MTN authorized personnel and via the number 0244 300 000 and not via SMS.`,
    },
    {
      title: ``,
      details: `Where there is a tie, priority will be given to customers with a longer tenure as a customer with MTN.`,
    },
    {
      title: ``,
      details: `Where there is a tie in tenure, three months average revenue per user (ARPU) prior to the promo month will be used to select a winner.`,
    },
    {
      title: ``,
      details: `Prizes will be rolled over to the next highest ranked after exhausting all efforts to reach the winner including calling their frequently called numbers for assistance without success in 48 hours.`,
    },
    {
      title: ``,
      details: `Winners duly informed of their prizes will be given a two-week period to claim their prize or indicate interest in the prize. If the winners selected are not available to claim the prize, such prizes will be returned to the prize chest and added to the prizes for the next Promo.`,
    },
    {
      title: ``,
      details: `By participating in the Promo, the Customer expressly agree that personal data which they supply shall be processed by the MTN for the purpose of executing the Promo and also for the purpose of publicizing the Promotion and MTN. It is hereby`,
    },
    {
      title: `PROMOTION DURATION`,
      details: `The duration of the Promo shall be from October 1 2021 to November 30, 2021.`,
    },
    {
      title: ``,
      details: `The duration of the Promo may be extended whenever MTN deems it appropriate.`,
    },
    {
      title: `ELIGIBILTY RULES`,
      details: `Pulse and Chill Promotion (“Promo”) is exclusive to all MTN Pulse customers (both on USSD and App).`,
    },
    {
      title: ``,
      details: `MTN Staff, their spouses, siblings, parents and children as well as third party agents are exempted from this Promo.`,
    },
    {
      title: `ABUSE AND DISQUALIFICATION`,
      details: `MTN reserves the right to disqualify a frontrunner when it is proven that the frontrunner used a fraudulent means to participate in the promo.`,
    },
    {
      title: `PERSONAL DATA PROTECTION`,
      details: `By participating in the Promo, the customer expressly agrees that personal data which they supply shall be processed by the MTN for the purpose of executing the Promo and also for the purpose of publicizing the Promo and MTN. MTN guarantees that the sharing of such personal data with third parties (including through television, the press, leaflets and other means and format of communication) shall be made only with respect to the winners of the prizes and will only indicate the given names and surnames of the winners, their images and voices, made for the sole purpose of publicity connected to the Promo. Participation in the Promo shall be deemed as an express consent for the use of this data in the manner herein defined.`,
    },
    {
      title: ``,
      details: `Notwithstanding the above, personal data of participants will be retained by MTN in accordance with the Data Protection laws of Ghana and personal data collected during this Promo will be treated as private and confidential.`,
    },
    {
      title: `GOVERNING LAW & AMENDMENTS`,
      details: `This Promo is organized under and governed by the laws and statutes of Ghana.`,
    },
    {
      title: ``,
      details: `These Terms & Conditions are valid during the Promo period until amended or suspended by MTN.`,
    },
    {
      title: `APPLICABLE TO IOS USERS: THE PULSE AND CHILL PROMO IS SOLELY UNDER THE AUSPICES OF MTN FOR WHICH APPLE INC IS NOT INVOLVED IN ANY SHAPE OR FORM.`,
      details: ``,
    },
  ],
};

export default pulsechillTNC;
